export default __webpack_public_path__ + "static/media/genom-ready@3x.c49eb510.png";